import axios from "axios";
import { astrolearnBaseImg } from "./astrolearnBaseImg";

type LeadPayLoad = {
  name: string;
  email: string;
  phone: string;
  source: string;
  comment: string;
  masterclassSlotId: string;
  masterclassId: string;
};

type paymentPlatfom = "FACEBOOK" | "GOOGLE";

const paymentTokens = {
  FACEBOOK:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOjk5LCJpYXQiOjE3NDQ0NDAzMDR9.6yfD5szTTP3y2FkPZAOcXbRaU3JUxNiNWdkhu0mX5zk",
  GOOGLE:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOjQ5LCJpYXQiOjE3NDQ0NDAyMzV9.grKK26hq373iIppM-D6lt7RbEZOPw4wUcrW-F5Bj0Mo",
  CUSTOM:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOjE5OSwiaWF0IjoxNzQ0NDQwMzQxfQ.FDKYqhW63lwgGlNvHJ8wBQUU8nr14a2RMAHx2R-A8QI",
};

const paymentMethods = {
  FACEBOOK: "paidBootcamp",
  GOOGLE: "paidMasterClass",
};

async function fetchUserIp() {
  try {
    const response = await axios.get("https://api.ipify.org?format=json");
    return response.data.ip;
  } catch (error) {
    console.error("Error fetching IP address:", error);
    return "0.0.0.0"; // Fallback IP in case of error
  }
}

export async function createPaymentOrder({
  paymentToken,
  redirectLink,
  paymentMethod,
  leadPayload,
  platform,
  masterClassData,
  paymentName,
  onSuccess,
}: {
  paymentToken?: string;
  redirectLink?: string;
  paymentMethod?: string;
  leadPayload: any;
  platform?: paymentPlatfom;
  masterClassData: any;
  paymentName?: string;
  onSuccess?: () => void;
}) {
  try {
    const userIp = await fetchUserIp();

    // Create the options payload for the API request
    const options = {
      masterClassId: masterClassData.id || "",
      name: leadPayload.name,
      phone: leadPayload.phone,
      email: leadPayload.email,
      paymentMethodType: paymentMethod
        ? paymentMethod
        : platform
        ? paymentMethods[platform]
        : "paidMasterClass",
      userIp, // Use fetched IP here
      comment: leadPayload.comment || "default_comment",
      token: paymentToken
        ? paymentToken
        : platform
        ? paymentTokens[platform]
        : paymentTokens.CUSTOM,
      origin: window.location.href,
      astroReportData: {
        dob: leadPayload?.dob,
        time: leadPayload?.time,
        placeofbirth: leadPayload?.placeofbirth,
        latitude: leadPayload?.latitude,
        longitude: leadPayload?.longitude,
      },
    };

    // Send request to create the order
    const response = await axios.post(
      `${process.env.NEXT_PUBLIC_BASE_API}payments/create-order`,
      options
    );

    const { id, gatewayOrderId, amount } = response.data.data;

    // Setup Razorpay options
    const razorpayOptions = {
      prefill: {
        name: leadPayload.name,
        email: leadPayload.email,
        contact: "+91" + String(leadPayload.phone),
      },
      key: process.env.NEXT_PUBLIC_RAZORPAY_KEY,
      amount: Number(amount),
      currency: "INR",
      name: paymentName ? paymentName : `Masterclass: ${masterClassData.title}`,
      description:
        masterClassData?.metaData?.workshopTitle || masterClassData.title,
      image: astrolearnBaseImg,
      handler: async function (response: any) {
        try {
          await axios.post(
            `${process.env.NEXT_PUBLIC_BASE_API}payments/authenticate/razorpay-payment`,
            {
              order_id: gatewayOrderId,
              company: "ASTROJI",
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            }
          );
          if (onSuccess) onSuccess();
          if (redirectLink) window.location.href = redirectLink;
        } catch (error) {
          window.location.href = `/payment-not-verified`;
        }
      },
      order_id: gatewayOrderId,
      theme: {
        color: "#000",
      },
    };

    // Open Razorpay payment window
    // @ts-ignore
    const rzp1 = new window.Razorpay(razorpayOptions);
    rzp1.open();
  } catch (error) {
    console.error("Error creating payment order:", error);
    throw new Error("Payment creation failed");
  }
}
